import { ICommentsResponse } from "src/api/client/comment-v2.api";
import { TComment, TCommentsPage } from "src/components/common/comments-area/comment/comment.types";

type TMapInfiniteQueryPagesParams = {
    pages: ICommentsResponse[];
    callback: (comment: TComment[]) => TComment[];
};

export const mapInfiniteQueryPages = ({ pages, callback }: TMapInfiniteQueryPagesParams): TCommentsPage[] => {
    return pages.map(page => ({
        comments: callback([...page.comments]),
        commentsCount: page.commentsCount,
    }));
};
